import classNames from "classnames";
import { Constants } from "../../../../../common/constants";
import { AttendeeRoleDataWithIDs } from "../../../../../common/sesh_types";
import { DashboardUtils, RevertDescriptor } from "../../dashboard_utils";
import { AddRoleToAttendeesComponent } from "./add_role_to_attendees_component";

const default_attendee_role_data: AttendeeRoleDataWithIDs = {
	role_ids: [],
	remove_on_end: Constants.DEFAULT_REMOVE_ROLE_ON_EVENT_END,
	role_add_time: Constants.DEFAULT_ADD_ROLE_ON_RSVP_ADD_TIME,
};

export function AddRoleToAttendeesEventForm(props: {
	value: AttendeeRoleDataWithIDs | undefined;
	setValue: (val: AttendeeRoleDataWithIDs | undefined) => void;
	sesh_role_name: string;
	sesh_has_manage_roles: boolean;
	is_server_premium: boolean;

	event_duration_ms?: number;
	disabled?: boolean;
	has_no_roles_to_add?: boolean;
	revert_descriptor?: RevertDescriptor<AttendeeRoleDataWithIDs>;
	unsaved_changes?: boolean;
	is_overridden?: boolean;
}) {
	return (
		<div
			className={classNames("field", { active: props.is_server_premium })}
		>
			{DashboardUtils.CreateHeaderAndInfoButton(
				"Add Role to Attendees",
				"Discord roles users will be granted upon RSVP or Event Start",
				!props.is_server_premium,
				false,
				false,
				undefined,
				props.disabled,
				false,
				props.is_server_premium ? props.revert_descriptor : undefined
			)}
			<AddRoleToAttendeesComponent
				value={props.value}
				setValue={(val) => {
					props.setValue(val);
				}}
				sesh_has_manage_roles={props.sesh_has_manage_roles}
				sesh_role_name={props.sesh_role_name}
				event_duration_ms={props.event_duration_ms}
				disabled={props.disabled || !props.is_server_premium}
				has_no_roles_to_add={props.has_no_roles_to_add}
			/>
		</div>
	);
}
